import { render, staticRenderFns } from "./column7.vue?vue&type=template&id=7ddd5406&scoped=true&"
import script from "./column7.vue?vue&type=script&lang=js&"
export * from "./column7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddd5406",
  null
  
)

component.options.__file = "column7.vue"
export default component.exports